import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Block } from 'jsxstyle';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { SemiBold } from './Styling';
import * as React from 'react';

export const Button = ({ type, children, onClick }: any) => {
    const colors = {
        success: '#50B748',
        cancel: '#686868'
    };
    const icons = {
        success: faCheck,
        cancel: faTimes
    };
    return (
        <Row
            minWidth={80}
            justifyContent="center"
            alignItems="center"
            padding="0px 10px"
            height={40}
            color="white"
            cursor="pointer"
            backgroundColor={colors[type]}
            props={{ onClick }}
        >
            <Block marginRight={10}>
                <FontAwesomeIcon size="lg" icon={icons[type]} />
            </Block>
            <SemiBold>{children}</SemiBold>
        </Row>
    );
};



// WEBPACK FOOTER //
// ./src/Button.tsx